import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { HOME_ROUTE } from "@hypexone/uicore";
import RegisterPage from "./SignUpPage";
import SignUpModal from "./SignUp/SignUpModal";

const SignUpRouteHandler = () => {
  const navigate = useNavigate();

  if (isMobile) {
    return <RegisterPage />;
  }

  return <SignUpModal onClose={() => navigate(HOME_ROUTE)} />;
};

export default SignUpRouteHandler;
